/**
 * Pikestee product cards: colour swatches (snippets/card-swatches.liquid).
 * Hover or click on a swatch shows that colour's photo on the card and points the card links to that variant.
 * One listener for the whole page (it used to be an inline script repeated on every swatch).
 */
(() => {
  if (window.__pkCardSwatches) return;
  window.__pkCardSwatches = true;

  const apply = (swatch) => {
    const card = swatch.closest('.card-wrapper');
    if (!card) return;
    const image = card.querySelector('.card__media img');
    if (image && swatch.dataset.src) {
      image.srcset = swatch.dataset.srcset;
      image.src = swatch.dataset.src;
    }
    card.classList.add('is-swatched');
    card.querySelectorAll('.card-swatch').forEach((button) => button.classList.toggle('is-active', button === swatch));
    if (swatch.dataset.url) {
      card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
        link.href = swatch.dataset.url;
      });
    }
  };

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest?.('.card-swatch');
    if (swatch) apply(swatch);
  });

  // Same as mouseenter on each swatch (mouseover bubbles, mouseenter does not)
  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest?.('.card-swatch');
    if (!swatch || swatch.contains(event.relatedTarget)) return;
    apply(swatch);
  });
})();
